import Rete from "rete";
import VueAssetControl from "./AssetControl.vue";

export class AssetControl extends Rete.Control {
  constructor(key, label, restrictTypes, dropZone) {
    super(key);
    this.component = VueAssetControl;
    this.props = { ikey: key, label, restrictTypes, dropZone };
  }
}
